import React,{Component} from "react";
import {Modal,Button} from 'react-bootstrap';
import errorlogo from "./images/error.png";
import successlogo from "./images/success.png";

import "./header/Header.css";

//const axios = require("axios");
export default class MymodalLeave extends Component {
    constructor(props) { 
        super(props);
        this.state = {heading:props.heading,
            isLoaded: false,
            modallogo:errorlogo,
            isOpen:true
        }
        this.closeModal = this.closeModal.bind(this);
//        this.openModal = this.openModal.bind(this);

      }
    openModal(e){
      this.setState({ isOpen: true })
    }
    closeModal(e){
      this.props.ErrHandler;
      this.setState({ isOpen: false });
    }
    componentDidMount()
    {
      if(this.props.Type === "1")
        this.setState({modallogo:errorlogo});
      else
      this.setState({modallogo:successlogo});
    }    
  render()
  {
      return(
        <React.Fragment>
        <Modal show={this.state.isOpen}   backdrop="static" aria-labelledby="contained-modal-title-vcenter" animation={false} centered  >
          <Modal.Header style={{backgroundColor:"gray", color:"white", height:"40px", paddingTop:5}}>
            <Modal.Title style={{ paddingTop:0}}> {this.props.Title}</Modal.Title>
          </Modal.Header> 
          <Modal.Body style={{ height:"75px", textAlign:"left"}}><img src={this.state.modallogo} alt="" style={{height:"25px",width:"30px", paddingRight:5}}/>{this.props.Body}</Modal.Body>
          <Modal.Footer>

            <Button variant="secondary" onClick={this.props.handler.bind(this)}>
{/*}            <Button variant="secondary" onClick={this.closeModal}>*/}
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
      )
    }
  }      